export default __webpack_public_path__ + "static/media/2137.59aa8ea0.png";